export default __webpack_public_path__ + "static/media/educator.dccd707e.png";